/* global G */
import showToast from 'app/_shared/component/showToast'

/**
 * @typedef {Object} ToastHookOptions
 * @property {ToastOptions} success
 * @property {ToastOptions} failure
 */

/**
 * Displays a toast with state `options.failure` if calling passed `hook` throws an error.
 * Otherwise, displays a toast with state `options.success`.
 *
 * @param {function(*): function(...[*]): Promise<*>} hook
 * @param {ToastHookOptions} options
 * @returns {function(*): function(...[*]): Promise<*>}
 */
const withToast = (hook, options) => obj => async (...args) => {
  let result = args

  try {
    result = await hook(obj)(...args)
    await showToast(obj, options.success)
  } catch (e) {
    await showToast(obj, options.failure)
    throw e
  }

  return result
}

export default withToast
